import { PermitDelegationPage } from "modules/permit/pages/PermitDelegationPage"

interface PermitDelegationConfigurationProps {
  currentUser?: any
}

const flattenTenantRoles = (currentUser?: any) => {
  if (!Array.isArray(currentUser?.tenants)) {
    return []
  }

  return currentUser.tenants.flatMap((tenant: any) => (Array.isArray(tenant?.roles) ? tenant.roles : []))
}

export default function PermitDelegationConfiguration({ currentUser }: PermitDelegationConfigurationProps) {
  return <PermitDelegationPage mode="admin" currentUser={currentUser} roles={flattenTenantRoles(currentUser)} />
}
